/**
 * Layout Component
 * Wraps pages with Header
 */

import Header from './Header';
import { OPERATOR_NAME, PRODUCT_NAME } from '@/config/branding';

interface LayoutProps {
  children: React.ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const showPoweredBy = OPERATOR_NAME !== PRODUCT_NAME;

  return (
    <div
      className="min-h-screen flex flex-col"
      style={{ backgroundColor: 'var(--bg-primary)' }}
    >
      <Header />
      <main className="flex-1">{children}</main>
      {showPoweredBy && (
        <footer className="py-3 text-center">
          <p className="text-xs" style={{ color: 'var(--text-tertiary)' }}>
            Powered by <span className="font-medium">{PRODUCT_NAME}</span>
          </p>
        </footer>
      )}
    </div>
  );
}
